import { msg } from '@lingui/macro';

export const PurchaseOrderRoutes = {
  path: 'purchase-orders',
  async lazy() {
    const { Parent } = await import('pages/purchase-orders');
    return { Component: Parent };
  },
  handle: { name: 'Supplier management', category: 'Supplier management' },
  children: [
    {
      path: '',
      async lazy() {
        const { Index } = await import('pages/purchase-orders');
        return { Component: Index };
      },
      handle: { title: msg`Mapping request overview` },

      children: [
        {
          path: 'add',
          async lazy() {
            const { AddPurchaseOrder } = await import('pages/purchase-orders');
            return { Component: AddPurchaseOrder };
          },
          handle: { name: 'Add new purchase order', category: 'Supplier management' },
        },
        {
          path: 'details/:poOrgId/:purchaseOrderId',
          async lazy() {
            const { DetailsPurchaseOrder } = await import('pages/purchase-orders');
            return { Component: DetailsPurchaseOrder };
          },
          handle: { name: 'Purchase order details', category: 'Supplier management' },
        },
      ],
    },
    {
      path: ':poOrgId/:purchaseOrderId',
      children: [
        {
          path: 'edit',
          async lazy() {
            const { EditPurchaseOrder } = await import('pages/purchase-orders');
            return { Component: EditPurchaseOrder };
          },
          handle: { name: 'Edit purchase order', category: 'Supplier management' },
        },
        {
          path: 'mapSuppliers',
          async lazy() {
            const { MapSuppliersPurchaseOrder } = await import('pages/purchase-orders');
            return { Component: MapSuppliersPurchaseOrder };
          },
          handle: { name: 'Map-suppliers purchase order', category: 'Supplier management' },
          children: [
            {
              path: 'stylesDetail/:styleId',
              async lazy() {
                const { PurchaseOrderStylesMapDrawer } = await import('pages/purchase-orders');
                return { Component: PurchaseOrderStylesMapDrawer };
              },
              handle: { name: 'Styles map drawer', category: 'Supplier management' },
            },
            {
              path: 'itemsDetail/:itemId',
              async lazy() {
                const { PurchaseOrderItemsMapDrawer } = await import('pages/purchase-orders');
                return { Component: PurchaseOrderItemsMapDrawer };
              },
              handle: { name: 'Items map drawer', category: 'Supplier management' },
            },
          ],
        },
        {
          path: 'reviewAndApprove',
          async lazy() {
            const { ReviewAndApprovePurchaseOrder } = await import('pages/purchase-orders');
            return { Component: ReviewAndApprovePurchaseOrder };
          },
          handle: { name: 'Review and approve purchase order', category: 'Supplier management' },
          children: [
            {
              path: 'supplierDetail/:supplierId/:subSupplierOrgId',
              async lazy() {
                const { DetailSupplierDrawer } = await import('pages/purchase-orders');
                return { Component: DetailSupplierDrawer };
              },
              handle: { name: 'Supplier detail drawer', category: 'Supplier management' },
            },
          ],
        },
        {
          path: 'full-details',
          async lazy() {
            const { CompletedMappingRequestFullView } = await import('pages/purchase-orders');
            return { Component: CompletedMappingRequestFullView };
          },
          handle: { name: 'Completed mapping request full view', category: 'Supplier management' },
        },
      ],
    },
  ],
};
